export default __webpack_public_path__ + "static/media/logo.ff7ba237.png";